module.exports = __webpack_public_path__ + "images/onboarding/hillary_hall.jpg";